import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import PlanHistoryModal from './PlanHistoryModal';

const PlanHistoryIcon = ({ planId, planTitle }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Tooltip title="View Plan History">
        <Button
          type="text"
          icon={<HistoryOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            setModalVisible(true);
          }}
          size="small"
        />
      </Tooltip>
      
      <PlanHistoryModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        planId={planId}
        planTitle={planTitle}
      />
    </>
  );
};

export default PlanHistoryIcon;
